/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    InternalApiEntityType,
    InternalApiEntityTypeFromJSON,
    InternalApiEntityTypeToJSON,
    InternalApiScreeningClearanceRule,
    InternalApiScreeningClearanceRuleFromJSON,
    InternalApiScreeningClearanceRuleToJSON,
    InternalApiScreeningClearanceRuleWithAllContents,
    InternalApiScreeningClearanceRuleWithAllContentsFromJSON,
    InternalApiScreeningClearanceRuleWithAllContentsToJSON,
    InternalApiScreeningClearanceRulesPage,
    InternalApiScreeningClearanceRulesPageFromJSON,
    InternalApiScreeningClearanceRulesPageToJSON,
    InternalApiSortDirection,
    InternalApiSortDirectionFromJSON,
    InternalApiSortDirectionToJSON,
} from '../models';

export interface AddRuleRequest {
    internalApiScreeningClearanceRule: InternalApiScreeningClearanceRule;
}

export interface DeleteRuleRequest {
    handle: string;
}

export interface FindAllRequest {
    page: number;
    size: number;
    entityType?: InternalApiEntityType;
    query?: string;
    orderBy?: string;
    direction?: InternalApiSortDirection;
}

export interface GetRuleRequest {
    handle: string;
}

export interface UpdateRuleRequest {
    handle: string;
    internalApiScreeningClearanceRule: InternalApiScreeningClearanceRule;
}

/**
 * 
 */
export class ScreeningClearanceRuleApi extends runtime.BaseAPI {

    /**
     * Creates new screening clearance rule
     */
    async addRuleRaw(requestParameters: AddRuleRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<InternalApiScreeningClearanceRule>> {
        if (requestParameters.internalApiScreeningClearanceRule === null || requestParameters.internalApiScreeningClearanceRule === undefined) {
            throw new runtime.RequiredError('internalApiScreeningClearanceRule','Required parameter requestParameters.internalApiScreeningClearanceRule was null or undefined when calling addRule.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/screening-clearance-rules`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InternalApiScreeningClearanceRuleToJSON(requestParameters.internalApiScreeningClearanceRule),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InternalApiScreeningClearanceRuleFromJSON(jsonValue));
    }

    /**
     * Creates new screening clearance rule
     */
    async addRule(requestParameters: AddRuleRequest, initOverrides?: RequestInit): Promise<InternalApiScreeningClearanceRule> {
        const response = await this.addRuleRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete an screening clearance rule
     */
    async deleteRuleRaw(requestParameters: DeleteRuleRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.handle === null || requestParameters.handle === undefined) {
            throw new runtime.RequiredError('handle','Required parameter requestParameters.handle was null or undefined when calling deleteRule.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/screening-clearance-rules/{handle}`.replace(`{${"handle"}}`, encodeURIComponent(String(requestParameters.handle))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete an screening clearance rule
     */
    async deleteRule(requestParameters: DeleteRuleRequest, initOverrides?: RequestInit): Promise<void> {
        await this.deleteRuleRaw(requestParameters, initOverrides);
    }

    /**
     * Fetches all clearance rules
     */
    async findAllRaw(requestParameters: FindAllRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<InternalApiScreeningClearanceRulesPage>> {
        if (requestParameters.page === null || requestParameters.page === undefined) {
            throw new runtime.RequiredError('page','Required parameter requestParameters.page was null or undefined when calling findAll.');
        }

        if (requestParameters.size === null || requestParameters.size === undefined) {
            throw new runtime.RequiredError('size','Required parameter requestParameters.size was null or undefined when calling findAll.');
        }

        const queryParameters: any = {};

        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }

        if (requestParameters.size !== undefined) {
            queryParameters['size'] = requestParameters.size;
        }

        if (requestParameters.entityType !== undefined) {
            queryParameters['entityType'] = requestParameters.entityType;
        }

        if (requestParameters.query !== undefined) {
            queryParameters['query'] = requestParameters.query;
        }

        if (requestParameters.orderBy !== undefined) {
            queryParameters['orderBy'] = requestParameters.orderBy;
        }

        if (requestParameters.direction !== undefined) {
            queryParameters['direction'] = requestParameters.direction;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/screening-clearance-rules`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InternalApiScreeningClearanceRulesPageFromJSON(jsonValue));
    }

    /**
     * Fetches all clearance rules
     */
    async findAll(requestParameters: FindAllRequest, initOverrides?: RequestInit): Promise<InternalApiScreeningClearanceRulesPage> {
        const response = await this.findAllRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get screening clearance rule
     */
    async getRuleRaw(requestParameters: GetRuleRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<InternalApiScreeningClearanceRuleWithAllContents>> {
        if (requestParameters.handle === null || requestParameters.handle === undefined) {
            throw new runtime.RequiredError('handle','Required parameter requestParameters.handle was null or undefined when calling getRule.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/screening-clearance-rules/{handle}`.replace(`{${"handle"}}`, encodeURIComponent(String(requestParameters.handle))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InternalApiScreeningClearanceRuleWithAllContentsFromJSON(jsonValue));
    }

    /**
     * Get screening clearance rule
     */
    async getRule(requestParameters: GetRuleRequest, initOverrides?: RequestInit): Promise<InternalApiScreeningClearanceRuleWithAllContents> {
        const response = await this.getRuleRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update an existing screening clearance rule
     */
    async updateRuleRaw(requestParameters: UpdateRuleRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<InternalApiScreeningClearanceRule>> {
        if (requestParameters.handle === null || requestParameters.handle === undefined) {
            throw new runtime.RequiredError('handle','Required parameter requestParameters.handle was null or undefined when calling updateRule.');
        }

        if (requestParameters.internalApiScreeningClearanceRule === null || requestParameters.internalApiScreeningClearanceRule === undefined) {
            throw new runtime.RequiredError('internalApiScreeningClearanceRule','Required parameter requestParameters.internalApiScreeningClearanceRule was null or undefined when calling updateRule.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/screening-clearance-rules/{handle}`.replace(`{${"handle"}}`, encodeURIComponent(String(requestParameters.handle))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: InternalApiScreeningClearanceRuleToJSON(requestParameters.internalApiScreeningClearanceRule),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InternalApiScreeningClearanceRuleFromJSON(jsonValue));
    }

    /**
     * Update an existing screening clearance rule
     */
    async updateRule(requestParameters: UpdateRuleRequest, initOverrides?: RequestInit): Promise<InternalApiScreeningClearanceRule> {
        const response = await this.updateRuleRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
